export default "__VITE_ASSET__U$zOIoNT__"